<template>
  <Index :role="type" stepper :items="pertanyaan" :expansion="expansion" />
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Index from './base/Index';
import configsKasek from './configs/kasek';
import configsInstruktur from './configs/instruktur';
export default {
  name: 'Esai',
  components: { Index },
  data() {
    return {
      configsEsai: {
        kasek: configsKasek,
        instruktur: configsInstruktur,
      },
    };
  },
  created() {
    this.getPertanyaan(this.profilID);
  },
  computed: {
    ...mapState('preferensi', {
      instruktur: (state) => state.data?.instruktur ?? {},
      peserta: (state) => state.data?.peserta ?? {},
      config: (state) => state.data?.config ?? {},
    }),

    ...mapState('esai', {
      pertanyaan: (state) => state?.pertanyaan ?? [],
    }),

    profilID() {
      const id = this.peserta?.psp_profil_id ?? this.instruktur?.psp_profil_id;
      return id;
    },

    gelombang() {
      return 1; //Number(this.$getDeepObj(this.config, 'peserta.gelombang'));
    },

    type() {
      const isInstruktur = !!Object.keys(this.instruktur).length;
      return isInstruktur ? 'instruktur' : 'kasek';
    },

    expansion() {
      return this.$getDeepObj(this.configsEsai, `${this.type}.header.${this.gelombang}`) || [];
    },
  },
  methods: {
    ...mapActions('esai', ['getPertanyaan']),
  },
};
</script>
